import styled from 'styled-components';

export const GuideOrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 95vh;
  background-color: #f8fafc;
  overflow: hidden;
`;

export const StandLayoutWrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 20px;
  gap: 20px;
  overflow: hidden;

`;

export const DashboardGrid = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  height: 100%;
`;

export const DashboardColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 40%;
  height: 100%;
  overflow: hidden;
`;

export const CenterIllustrationColumn = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  .illustration-wrapper {
    margin-top: 15%;
    object-fit: contain;
  }
`;

export const StandNavigationHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  color: #0f172a;
  padding: 10px;
  width: 100%;
  background-color: #f1f5f9;
  border-radius: 8px;
`;

export const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 18%;
  min-width: 15%;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  .sidebar-actions {
    display: flex;
    flex-direction: column;
    padding-top: 18px;
    gap: 18px;

    button {
      width: 100%;
    }
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
`;

export const ComponentColumn = styled.div`
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow-y: auto;
  min-height: 0;
`;

export const BlockHeader = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 10px;
  margin-bottom: 12px;
`;

export const ComponentTable = styled.table`
  border-collapse: collapse;
  font-size: 13px;
  text-align: left;
  width: 100%;

  td {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
    vertical-align: middle;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr {
    transition: background-color 0.15s ease;
  }

  tbody tr:hover {
    background-color: #f8fafc;
  }

  td.label {
    font-weight: 500;
    color: #1e293b;
    width: 50%;
  }

  td.code {
    font-family: 'SFMono-Regular', monospace;
    color: #0f172a;
    font-weight: 600;
    width: 50%;
  }
`;

export const CodeLink = styled.a`
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #eff6ff;
  transition: all 0.15s ease;

  &:hover {
    background-color: #dbeafe;
    color: #1d4ed8;
    text-decoration: underline;
  }
`;

export const NoDataMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 14px;
  font-weight: 500;
`;

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const SuggestionCard = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  }
`;

export const SuggestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background-color: #ffffff;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f8fafc;
  }
`;

export const RankBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5vw;
  height: 2.5vh;
  font-size: 14px;
  font-weight: 700;
  color: #166534;
  background-color: #dcfce7;
  border-radius: 50%;
  border: 1px solid #bbf7d0;
  flex-shrink: 0;
`;


export const GuideTitle = styled.div`
  font-size: 14px;
  color: #334155;

  strong {
    color: #0f172a;
  }
`;

export const ChangeWarningTag = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: #fffbe6;
  color: #d97706;
  border: 1px solid #fef3c7;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  width: fit-content;
`;

export const ForcedSetupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  text-align: center;
`;

export const ForcedSetupTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
`;

export const ForcedSetupText = styled.p`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 24px;
`;

export const PdfModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;

  .pdf-toolbar {
    display: flex;
    justify-content: flex-end;
    padding: 8px 12px;
    background-color: #ffffff;
    border-bottom: 1px solid #e2e8f0;
  }

  iframe {
    height: 68vh;
    width: 100%;
    border: none;
  }
`;
